import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { LeaderBoardDataProps } from "../../modules/admin/dashboard/type";
import { SharedFeedbacksParams } from "../../type";
import { get } from "../../util/APIService";
import { HttpStatus } from "../../enums/httpStatus";

export const getLeaderWithFeedbackCount = createAsyncThunk(
  "admin/member/leaders",
  async (requestParams: SharedFeedbacksParams, storeActions) => {
    const url = `api/v1/admin/feedback/leader` + requestParams.requestingParams;
    const response: any = await get(url, storeActions);

    if (response.status === HttpStatus.OK) {
      return {
        status: HttpStatus.OK,
        data: await response.json(),
      };
    } else {
      return {
        status: response.status,
        text: await response.text(),
      };
    }
  }
);

const leadersWithFeedbackCountSlice = createSlice({
  name: "leadersWithFeedbackCount",
  initialState: {
    status: null as number | null,
    loading: false as boolean,
    text: null as string | null,
    data: [] as Array<LeaderBoardDataProps> | null,
  },
  reducers: {
    clearData: (state) => {
      state.status = null;
      state.loading = false;
      state.text = null;
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getLeaderWithFeedbackCount.fulfilled, (state, action) => {
      state.status = action.payload.status;
      state.loading = false;
      if (action.payload.data !== undefined) {
        state.data = action.payload.data;
        state.text = null;
      } else if (action.payload.text !== undefined) {
        state.data = null;
        state.text = action.payload.text;
      }
    });
    builder.addCase(getLeaderWithFeedbackCount.pending, (state) => {
      state.status = null;
      state.loading = true;
      state.data = null;
      state.text = null;
    });
    builder.addCase(getLeaderWithFeedbackCount.rejected, (state) => {
      state.status = 503;
      state.loading = false;
      state.data = null;
      state.text = null;
    });
  },
});

export const { clearData } = leadersWithFeedbackCountSlice.actions;

export default leadersWithFeedbackCountSlice;
